(function () {
  var THRESHOLD = 10000; // €100 in cents
  var busy = false;
  var obs = null;
  var popup = null;

  function fmt(c) {
    var eu = Math.floor(Math.abs(c) / 100), ce = Math.abs(c) % 100;
    var s = eu.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return (c < 0 ? '-' : '') + '€' + s + ',' + (ce < 10 ? '0' + ce : ce);
  }

  var TRUCK = "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.7' stroke-linecap='round' stroke-linejoin='round'><rect x='1.5' y='6.5' width='12' height='9' rx='1'/><path d='M13.5 9.5h4l3 3v3h-7z'/><circle cx='6' cy='17.6' r='1.6'/><circle cx='17' cy='17.6' r='1.6'/></svg>";
  var LOCK = "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.7' stroke-linecap='round' stroke-linejoin='round'><rect x='5' y='11' width='14' height='10' rx='2'/><path d='M8 11V7a4 4 0 0 1 8 0v4'/></svg>";
  var RETURN = "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.7' stroke-linecap='round' stroke-linejoin='round'><path d='M3 12a9 9 0 1 0 3-6.7L3 8'/><path d='M3 3v5h5'/></svg>";

  function payHTML() {
    var chips = [
      "<span class='bp-pay bp-pay--ideal'>iDEAL</span>",
      "<span class='bp-pay bp-pay--klarna'>Klarna</span>",
      "<span class='bp-pay'>VISA</span>",
      "<span class='bp-pay'>MC</span>",
      "<span class='bp-pay'>Apple&nbsp;Pay</span>",
      "<span class='bp-pay'>PayPal</span>",
      "<span class='bp-pay'>Bancontact</span>"
    ].join('');
    return "<div class='bp-cpay__trust'>" +
      "<span>" + LOCK + "Veilig betalen</span>" +
      "<span>" + TRUCK + "2–4 werkdagen</span>" +
      "<span>" + RETURN + "30 dagen bedenktijd</span>" +
      "</div><div class='bp-cpay__icons'>" + chips + "</div>";
  }

  function discountInfo(cart) {
    var apps = cart.cart_level_discount_applications || [];
    if (apps.length) {
      var amt = 0, i;
      for (i = 0; i < apps.length; i++) amt += (apps[i].total_allocated_amount || 0);
      return { applied: true, label: apps[0].title || 'Korting', amount: amt };
    }
    if (cart.total_discount && cart.total_discount > 0) {
      return { applied: true, label: 'Korting', amount: cart.total_discount };
    }
    return { applied: false };
  }

  function apply(cart) {
    var total = cart.total_price, count = cart.item_count;
    busy = true;
    try {
      var reached = total >= THRESHOLD;
      var rem = Math.max(0, THRESHOLD - total);
      var pct = reached ? 100 : Math.max(3, Math.round(total * 100 / THRESHOLD));
      var msg = reached ? "Gelukt! Je bestelling wordt <b>gratis verzonden</b>." : "Nog <b>" + fmt(rem) + "</b> tot <b>gratis verzending</b>";

      var pdps = document.querySelectorAll('.pdp-ship');
      for (var i = 0; i < pdps.length; i++) {
        var s = pdps[i].querySelector('.pdp-ship__row span');
        var f = pdps[i].querySelector('.pdp-ship__track i');
        if (s) s.innerHTML = reached ? "Gelukt — je bestelling wordt <b>gratis verzonden</b>." : "Nog <b>" + fmt(rem) + "</b> tot <b>gratis verzending</b>";
        if (f) f.style.width = pct + '%';
      }

      var cbsts = document.querySelectorAll('.cbst');
      for (var j = 0; j < cbsts.length; j++) {
        var thr = parseInt(cbsts[j].getAttribute('data-threshold'), 10) || THRESHOLD;
        var r = total >= thr, rm = Math.max(0, thr - total), p = r ? 100 : Math.max(3, Math.round(total * 100 / thr));
        var t = cbsts[j].querySelector('.cbst__txt');
        var cf = cbsts[j].querySelector('.cbst__fill');
        if (t) t.innerHTML = r ? "Gelukt! Je bestelling wordt <b>gratis verzonden</b>" : "Nog <b>" + fmt(rm) + "</b> tot <b>gratis verzending</b>";
        if (cf) cf.style.width = p + '%';
      }

      var cd = document.querySelector('cart-drawer');
      var inner = cd && cd.querySelector('.drawer__inner');
      if (inner) {
        var empty = cd.classList.contains('is-empty') || total === 0;

        // Count badge
        var head = inner.querySelector('.drawer__heading');
        if (head) {
          var badge = head.querySelector('.bp-cartcount');
          if (count > 0) {
            if (!badge) { badge = document.createElement('span'); badge.className = 'bp-cartcount'; head.appendChild(badge); }
            badge.textContent = count;
          } else if (badge) { badge.parentNode.removeChild(badge); }
        }

        // Progress bar (Kosso-style, single free-shipping goal)
        var bar = inner.querySelector('.cdfs');
        if (empty) {
          if (bar && bar.parentNode) bar.parentNode.removeChild(bar);
        } else {
          var h = inner.querySelector('.drawer__header');
          if (!bar && h) {
            bar = document.createElement('div');
            bar.className = 'cdfs';
            bar.innerHTML = "<p class='cdfs__msg'><span class='cdfs__txt'></span></p><div class='cdfs__bar'><div class='cdfs__track'><span class='cdfs__fill'></span></div><span class='cdfs__goal'>" + TRUCK + "</span></div>";
            h.insertAdjacentElement('afterend', bar);
          }
          if (bar) {
            bar.querySelector('.cdfs__txt').innerHTML = msg;
            bar.querySelector('.cdfs__fill').style.width = pct + '%';
            bar.className = reached ? 'cdfs is-done' : 'cdfs';
          }
        }

        // Footer: summary (Korting / Verzendkosten / Totaal) + payment
        var foot = inner.querySelector('.drawer__footer');
        if (foot && !empty) {
          var ctas = foot.querySelector('.cart__ctas');
          var sum = foot.querySelector('.bp-sum');
          if (!sum && ctas) {
            sum = document.createElement('div');
            sum.className = 'bp-sum';
            sum.innerHTML =
              "<button class='bp-sum__row bp-sum__disc' type='button'><span class='bp-sum__label'>Korting</span><span class='bp-sum__val' data-bp-disc>Code toevoegen ›</span></button>" +
              "<div class='bp-sum__row'><span class='bp-sum__label'>Verzendkosten</span><span class='bp-sum__val'>Berekend bij afrekenen</span></div>" +
              "<div class='bp-sum__row bp-sum__total'><span class='bp-sum__label'>Totaal</span><span class='bp-sum__val' data-bp-total></span></div>";
            foot.insertBefore(sum, ctas);
          }
          if (sum) {
            var di = discountInfo(cart);
            var dv = sum.querySelector('[data-bp-disc]');
            if (dv) {
              if (di.applied) { dv.innerHTML = "<b>" + di.label + "</b> &nbsp;−" + fmt(di.amount) + " &nbsp;<span class='bp-sum__edit'>wijzig</span>"; sum.querySelector('.bp-sum__disc').classList.add('is-applied'); }
              else { dv.textContent = 'Code toevoegen ›'; sum.querySelector('.bp-sum__disc').classList.remove('is-applied'); }
            }
            var tv = sum.querySelector('[data-bp-total]');
            if (tv) tv.textContent = fmt(total);
          }

          var pay = foot.querySelector('.bp-cpay');
          if (!pay) {
            pay = document.createElement('div');
            pay.className = 'bp-cpay';
            pay.innerHTML = payHTML();
            foot.appendChild(pay);
          }
        }
      }
    } finally {
      setTimeout(function () { busy = false; }, 0);
    }
  }

  function refresh() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { apply(c); return c; })
      .catch(function () {});
  }

  // ----- Discount popup -----
  function ensurePopup() {
    if (popup) return popup;
    popup = document.createElement('div');
    popup.className = 'bp-dpop';
    popup.setAttribute('hidden', '');
    popup.innerHTML =
      "<div class='bp-dpop__bg' data-bp-close></div>" +
      "<div class='bp-dpop__box' role='dialog' aria-modal='true'>" +
      "<button class='bp-dpop__close' type='button' data-bp-close aria-label='Sluiten'>×</button>" +
      "<h3 class='bp-dpop__title'>Kortingscode</h3>" +
      "<div class='bp-dpop__row'><input class='bp-dpop__input' type='text' autocomplete='off' placeholder='Voer je code in'><button class='bp-dpop__apply' type='button'>Toepassen</button></div>" +
      "<p class='bp-dpop__msg' hidden></p>" +
      "</div>";
    document.body.appendChild(popup);
    return popup;
  }
  function openPopup() {
    ensurePopup();
    popup.removeAttribute('hidden');
    var msg = popup.querySelector('.bp-dpop__msg'); if (msg) { msg.setAttribute('hidden', ''); msg.className = 'bp-dpop__msg'; }
    var inp = popup.querySelector('.bp-dpop__input'); if (inp) { setTimeout(function () { inp.focus(); }, 30); }
  }
  function closePopup() { if (popup) popup.setAttribute('hidden', ''); }
  function popMsg(text, ok) {
    var m = popup.querySelector('.bp-dpop__msg');
    m.textContent = text; m.className = 'bp-dpop__msg ' + (ok ? 'is-ok' : 'is-err'); m.removeAttribute('hidden');
  }
  function applyDiscount() {
    var inp = popup.querySelector('.bp-dpop__input');
    var code = (inp.value || '').trim();
    if (!code) { inp.focus(); return; }
    var btn = popup.querySelector('.bp-dpop__apply');
    btn.disabled = true; btn.textContent = 'Bezig…';
    fetch('/discount/' + encodeURIComponent(code), { method: 'GET' })
      .then(function () { return refresh(); })
      .then(function (cart) {
        btn.disabled = false; btn.textContent = 'Toepassen';
        var di = cart ? discountInfo(cart) : { applied: false };
        if (di.applied) { popMsg('Korting toegepast: ' + di.label + ' (−' + fmt(di.amount) + ')', true); setTimeout(closePopup, 900); }
        else { popMsg('We konden deze code niet toepassen. Controleer de code, of hij wordt bij het afrekenen verrekend.', false); }
      })
      .catch(function () { btn.disabled = false; btn.textContent = 'Toepassen'; popMsg('Er ging iets mis. Probeer het opnieuw.', false); });
  }

  document.addEventListener('click', function (e) {
    var disc = e.target.closest && e.target.closest('.bp-sum__disc');
    if (disc) { e.preventDefault(); openPopup(); return; }
    if (e.target.closest && e.target.closest('[data-bp-close]')) { closePopup(); return; }
    if (e.target.closest && e.target.closest('.bp-dpop__apply')) { applyDiscount(); return; }
  });
  document.addEventListener('keydown', function (e) {
    if (!popup || popup.hasAttribute('hidden')) return;
    if (e.key === 'Escape') { e.stopPropagation(); closePopup(); }
    else if (e.key === 'Enter' && e.target.classList && e.target.classList.contains('bp-dpop__input')) { e.preventDefault(); applyDiscount(); }
  }, true);

  // Catch cart mutations for live sync
  var of = window.fetch;
  if (of) {
    window.fetch = function () {
      var a = arguments, u = '';
      try { u = (a[0] && a[0].url) ? a[0].url : (typeof a[0] === 'string' ? a[0] : ''); } catch (e) {}
      var pr = of.apply(this, a);
      if (u && /\/cart\/(add|change|update|clear)/.test(u)) {
        pr.then(function () { setTimeout(refresh, 80); }).catch(function () {});
      }
      return pr;
    };
  }

  function initObs() {
    var cd = document.querySelector('cart-drawer');
    if (!cd || obs) return;
    obs = new MutationObserver(function () { if (busy) return; refresh(); });
    obs.observe(cd, { childList: true, subtree: true });
  }

  var css =
    // progress bar (Kosso-style, separated band)
    ".cdfs{margin:0;padding:1.7rem 2.4rem;border-bottom:1px solid rgba(var(--color-foreground),.12);background:rgb(var(--color-background))}" +
    ".cdfs__msg{margin:0 0 1.1rem;font-size:1.3rem;line-height:1.3;color:rgb(var(--color-foreground))}" +
    ".cdfs__txt b{font-weight:700}" +
    ".cdfs__bar{display:flex;align-items:center;gap:1.2rem}" +
    ".cdfs__track{position:relative;flex:1;height:.7rem;border-radius:99px;background:rgba(var(--color-foreground),.12);overflow:hidden}" +
    ".cdfs__fill{display:block;height:100%;border-radius:99px;background:rgb(var(--color-button));transition:width .45s ease}" +
    ".cdfs__goal{flex:0 0 auto;width:3rem;height:3rem;border-radius:50%;border:1.5px solid rgba(var(--color-foreground),.22);background:rgb(var(--color-background));display:flex;align-items:center;justify-content:center;color:rgb(var(--color-foreground))}" +
    ".cdfs__goal svg{width:1.6rem;height:1.6rem}" +
    ".cdfs.is-done .cdfs__goal{background:rgb(var(--color-button));border-color:rgb(var(--color-button));color:#fff}" +
    // header
    "cart-drawer .drawer__header{align-items:center;padding-bottom:1.4rem;border-bottom:1px solid rgba(var(--color-foreground),.10)}" +
    "cart-drawer .drawer__heading{display:flex;align-items:center;gap:1rem;font-weight:700}" +
    ".bp-cartcount{display:inline-flex;align-items:center;justify-content:center;min-width:2.3rem;height:2.3rem;padding:0 .7rem;border-radius:99px;background:rgb(var(--color-button));color:#fff;font-size:1.15rem;font-weight:600;line-height:1;font-family:inherit}" +
    "cart-drawer .drawer__close{border:1px solid rgba(var(--color-foreground),.22);border-radius:99px;height:3.4rem;padding:0 1.3rem;display:inline-flex;align-items:center;gap:.6rem;font-size:1.1rem;font-weight:600;letter-spacing:.05em;text-transform:uppercase;color:rgb(var(--color-foreground));opacity:1}" +
    "cart-drawer .drawer__close::after{content:'Sluiten'}" +
    "cart-drawer .drawer__close .icon{width:1.3rem;height:1.3rem}" +
    // items
    "cart-drawer .cart-item__image{border-radius:1rem;border:1px solid rgba(var(--color-foreground),.08)}" +
    "cart-drawer .cart-item__name{font-weight:600}" +
    "cart-drawer .cart-item .product-option{opacity:.62;text-transform:uppercase;letter-spacing:.03em;font-size:1.1rem}" +
    "cart-drawer .quantity.cart-quantity{border:1px solid rgba(var(--color-foreground),.22);border-radius:99px;overflow:hidden;box-shadow:none}" +
    "cart-drawer .quantity.cart-quantity:after{display:none}" +
    "cart-drawer .cart-remove-button{border-radius:99px}" +
    // footer summary (Kosso-style)
    "cart-drawer .drawer__footer{border-top:1px solid rgba(var(--color-foreground),.10)}" +
    "cart-drawer .cart-drawer__footer{display:none}" +
    ".bp-sum{display:flex;flex-direction:column;gap:.9rem;margin:0 0 1.6rem}" +
    ".bp-sum__row{display:flex;align-items:center;justify-content:space-between;font-size:1.35rem;color:rgb(var(--color-foreground));background:none;border:0;padding:0;width:100%;text-align:left;font-family:inherit}" +
    ".bp-sum__label{opacity:.85}" +
    ".bp-sum__val{opacity:.85}" +
    ".bp-sum__disc{cursor:pointer}" +
    ".bp-sum__disc .bp-sum__val{color:rgb(var(--color-button));font-weight:600;opacity:1}" +
    ".bp-sum__disc.is-applied .bp-sum__val{color:rgb(var(--color-foreground))}" +
    ".bp-sum__edit{color:rgb(var(--color-button));text-decoration:underline;font-weight:500}" +
    ".bp-sum__total{border-top:1px solid rgba(var(--color-foreground),.12);padding-top:1.1rem;margin-top:.3rem}" +
    ".bp-sum__total .bp-sum__label{opacity:1;font-weight:700;font-size:1.55rem}" +
    ".bp-sum__total .bp-sum__val{opacity:1;font-weight:700;font-size:1.7rem}" +
    "cart-drawer .cart__checkout-button{border-radius:99px !important;text-transform:uppercase;letter-spacing:.05em;font-weight:700;min-height:5.4rem;font-size:1.35rem}" +
    // payment + trust
    ".bp-cpay{padding:1.4rem 0 .2rem}" +
    ".bp-cpay__trust{display:flex;justify-content:center;flex-wrap:wrap;gap:.8rem 1.6rem;margin:0 0 1.1rem;font-size:1.1rem;color:rgb(var(--color-foreground))}" +
    ".bp-cpay__trust span{display:inline-flex;align-items:center;gap:.5rem;opacity:.82}" +
    ".bp-cpay__trust svg{width:1.6rem;height:1.6rem;color:rgb(var(--color-button))}" +
    ".bp-cpay__icons{display:flex;justify-content:center;flex-wrap:wrap;gap:.6rem}" +
    ".bp-pay{height:2.4rem;min-width:3.6rem;border:1px solid rgba(var(--color-foreground),.16);border-radius:.5rem;display:inline-flex;align-items:center;justify-content:center;font-size:.95rem;font-weight:700;letter-spacing:.02em;background:#fff;padding:0 .7rem;color:#3E3A34}" +
    ".bp-pay--ideal{color:#cc0066}.bp-pay--klarna{background:#ffb3c7;border-color:#ffb3c7;color:#17120f}" +
    // discount popup
    ".bp-dpop{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:2rem}" +
    ".bp-dpop[hidden]{display:none}" +
    ".bp-dpop__bg{position:absolute;inset:0;background:rgba(0,0,0,.45)}" +
    ".bp-dpop__box{position:relative;background:rgb(var(--color-background));color:rgb(var(--color-foreground));border-radius:1.6rem;padding:2.8rem 2.6rem 2.6rem;max-width:40rem;width:100%;box-shadow:0 24px 70px rgba(0,0,0,.28)}" +
    ".bp-dpop__close{position:absolute;top:1.1rem;right:1.3rem;background:none;border:0;font-size:2.6rem;line-height:1;cursor:pointer;color:rgb(var(--color-foreground));opacity:.6}" +
    ".bp-dpop__title{margin:0 0 1.4rem;font-size:1.75rem;font-weight:700}" +
    ".bp-dpop__row{display:flex;gap:.8rem}" +
    ".bp-dpop__input{flex:1;min-width:0;border:1px solid rgba(var(--color-foreground),.28);border-radius:99px;padding:1.15rem 1.7rem;font-size:1.3rem;background:rgb(var(--color-background));color:rgb(var(--color-foreground));font-family:inherit}" +
    ".bp-dpop__input:focus{outline:none;border-color:rgb(var(--color-button))}" +
    ".bp-dpop__apply{border:0;border-radius:99px;background:rgb(var(--color-button));color:#fff;padding:0 2.1rem;font-weight:700;text-transform:uppercase;letter-spacing:.03em;font-size:1.2rem;cursor:pointer;font-family:inherit}" +
    ".bp-dpop__apply[disabled]{opacity:.6;cursor:default}" +
    ".bp-dpop__msg{margin:1.3rem 0 0;font-size:1.2rem;line-height:1.4}" +
    ".bp-dpop__msg.is-err{color:#b3261e}.bp-dpop__msg.is-ok{color:rgb(var(--color-button))}" +
    // hide the third-party floating "English ▼" language-switcher widget (translation app)
    ".floating-language-selector,#floating-language-selector{display:none !important}";
  var st = document.createElement('style');
  st.appendChild(document.createTextNode(css));
  document.head.appendChild(st);

  function start() { initObs(); refresh(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
